<div *ngIf="resellerRegistered" class="screen-container">
  <app-card [title]="'reseller.titleRegistered' | translate">
    <div left-content>
        <div class="first-paragraph-container">
          <div>{{ "reseller.firstParagraph" | translate }}</div>
          <div class="trackingUrl">{{ trackingUrl }} </div>
        </div>
    </div>
    <div right-content>
      <app-contact></app-contact>
    </div>
  </app-card>


</div>

<div *ngIf="!resellerRegistered" class="screen-container">
  <app-card [title]="'reseller.title' | translate">
    <div left-content>
  
      <form  [formGroup]="resellerForm">
        <div class="content-container">

          <div class="input-container">
            <app-search
              [label]="'reseller.companyNameOrId'"
              [control]="companyName"
              [options]="companies"
              [error]="getErrors('companyName')"
              [loading]="loading"
              (searchSelected)="handleSearchSelected($event)"
            >
            </app-search>
          </div>

          <div class="input-container">
            <app-input
              [label]="'reseller.email'"
              [control]="email"
              [error]="getErrors('email')"
              [inputMode]="'email'"
              [icon]="'email'"
            ></app-input>
          </div>

          <div class="input-container">
            <app-input
              [label]="'reseller.phoneNumber'"
              [control]="phoneNumber"
              [error]="getErrors('phoneNumber')"
              [inputMode]="'tel'"
              [type]="'text'"
              [icon]="'phone'"
            ></app-input>
          </div>

          <div class="input-container">
            <app-input
              [label]="'reseller.name'"
              [control]="name"
              [error]="getErrors('name')"
              [inputMode]="'text'"
              [type]="'text'"
              [icon]="'person'"
            ></app-input>
          </div>

          <div class="button-container">
            <button
              mat-flat-button
              color="primary"
              (click)="handleButtonClick()"
              [ngClass]="{ fullWidth: true }"
            >
              {{ 'reseller.buttonText' | translate }}
              <span
                *ngIf="loading"
                class="icon icon-loading"
              ></span>
            </button>
          </div>

          <div class="note">
            {{ "reseller.buttonNoteFirstPart" | translate }}
            <a [href]="resellerTosLink" class="link" target="_blank">
              {{ "reseller.terms" | translate }}</a
            >
            {{ "reseller.buttonNoteSecondPart" | translate }}
          </div>
          <div class="mat-error error" *ngIf="error">
            {{ error }}
          </div>
        </div>
      </form>
    </div>
    <div right-content>
      <app-contact></app-contact>
    </div>
  </app-card>
</div>
